const updates = [
  { id: 1, title: '《斗破苍穹》第428话 - 炎帝归来', tag: '热门更新', time: '2小时前', icon: 'ri-fire-line', accent: 'primary' },
  { id: 2, title: '《海贼王》第1120话 - 最终之战序幕', tag: '日漫更新', time: '3小时前', icon: 'ri-ship-line', accent: 'accent' },
  { id: 3, title: '《一人之下》第526话 - 天师下山', tag: '国漫更新', time: '4小时前', icon: 'ri-flag-line', accent: 'primary' },
  { id: 4, title: '《咒术回战》第263话 - 领域展开', tag: '日漫更新', time: '5小时前', icon: 'ri-flashlight-line', accent: 'accent' },
  { id: 5, title: '《狐妖小红娘》第486话 - 前世今生', tag: '国漫更新', time: '6小时前', icon: 'ri-heart-line', accent: 'primary' },
  { id: 6, title: '《女神降临》番外篇 - 婚后日常', tag: '韩漫更新', time: '昨天', icon: 'ri-star-line', accent: 'secondary' },
  { id: 7, title: '平台公告：新增韩漫专区上线', tag: '站点公告', time: '昨天', icon: 'ri-notification-line', accent: 'secondary' },
  { id: 8, title: '《修仙狂徒》第312话 - 突破境界', tag: '新作更新', time: '昨天', icon: 'ri-moon-line', accent: 'accent' },
  { id: 9, title: '《都市灵医》第89话 - 妙手回春', tag: '国漫更新', time: '2天前', icon: 'ri-flag-line', accent: 'primary' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            最新更新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            九妖漫画网实时更新列表，不错过任何一部精彩漫画的最新章节
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          {updates.map((item, index) => (
            <div
              key={item.id}
              className="relative flex items-start gap-4 pl-8 pb-6 last:pb-0 cursor-pointer group"
            >
              {/* Timeline line & dot */}
              <div className="absolute left-[7px] top-2 bottom-0 w-0.5 bg-background-300">
                {index === updates.length - 1 && (
                  <div className="absolute inset-0 bg-gradient-to-b from-background-300 to-transparent"></div>
                )}
              </div>
              <span className={`absolute left-0 top-1.5 w-[15px] h-[15px] rounded-full border-2 border-background-50 flex-shrink-0 ${
                item.accent === 'primary'
                  ? 'bg-primary-500'
                  : item.accent === 'accent'
                  ? 'bg-accent-500'
                  : 'bg-secondary-500'
              }`}></span>

              {/* Content */}
              <div className="flex-1 min-w-0 pt-0.5">
                <div className="flex flex-col sm:flex-row sm:items-center gap-1 sm:gap-3 mb-1">
                  <h3 className="font-medium text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.title}
                  </h3>
                  <span className={`inline-flex items-center gap-1 px-2 py-0.5 text-xs font-medium rounded-full whitespace-nowrap w-fit ${
                    item.accent === 'primary'
                      ? 'bg-primary-100 text-primary-600'
                      : item.accent === 'accent'
                      ? 'bg-accent-100 text-accent-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    <i className={`${item.icon} text-[10px]`}></i>
                    {item.tag}
                  </span>
                </div>
                <p className="text-xs text-foreground-400">{item.time}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}